import { createAction, props } from '@ngrx/store';
import { ICourse } from '../models/course.model';

export const getCourseActivity = createAction('[Course] Get Course Activity', (courseId: string) => ({ courseId }));
export const getCourseActivitySuccess = createAction('[Course] Get Course Activity success', (learningCourse: ICourse) => ({ learningCourse }));
export const getCourseActivityFailure = createAction('[Course] Get Course Activity failure', props<{ error: string }>());

export const getCourses = createAction('[Course] Get Courses');
export const getCoursesSuccess = createAction('[Course] Get Courses success', (courseList: ICourse[]) => ({ courseList }));
export const getCoursesFailure = createAction('[Course] Get Courses failure', props<{ error: string }>());

export const getCourse = createAction('[Course] Get Course', (courseId: string) => ({ courseId }));
export const getCourseSuccess = createAction('[Course] Get Course success', (course: ICourse) => ({ course }));
export const getCourseFailure = createAction('[Course] Get Course failure', props<{ error: string }>());

export const courseActions = {
    getCourseActivity,
    getCourseActivitySuccess,
    getCourseActivityFailure,
    getCourses,
    getCoursesSuccess,
    getCoursesFailure,
    getCourse,
    getCourseSuccess,
    getCourseFailure
}
